export const prices = {
    small: 3200,
    medium: 3900,
    suv: 4200,
    large: 4600,
}